import React from "react";
import PropTypes from "prop-types";

/**
 * This renders the mobile app download qr image with its description text.
 *
 * @param {Object} props - The object containing props.
 * @param {string} props.src - src for the image or key to find the svg in the QR_SVG constant in this file.
 * @param {string} props.altText - alt text for the image.
 * @param {Object} props.containerStyle - extra styles applied to the div containing the text and image.
 * @param {Object} props.style - custom style to force some visual requirements.
 * @param {string} props.textClass - text classes applied to the text below the image.
 * @param {string} props.text - you can change the text below the image here.
 * @returns {React.JSX.Element} Returns the JSX component to render
 */
const MobileAppQR = ({
  src = "",
  altText = "WaFd App QR Code",
  containerStyle = {},
  style = {},
  textClass = "text-secondary text-sm",
  text = "Scan to Download"
}) => {
  return (
    <div className="app-download-hub-element-container qr-image" style={containerStyle}>
      <img className="app-download-hub-qr-image" src={src} alt={altText} style={style} />
      <p className={"text-center mb-0 " + textClass}>{text}</p>
    </div>
  );
};

export default MobileAppQR;

MobileAppQR.propTypes = {
  src: PropTypes.string.isRequired,
  altText: PropTypes.string,
  style: PropTypes.object,
  textClass: PropTypes.string,
  text: PropTypes.string
};
